import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { useTranslate } from 'react-admin';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router';

const NotAllowedPage = () => {
    const translate = useTranslate();
    const navigate = useNavigate();

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                alignItems: 'center',
                justifyContent: 'center',
                p: 4,
            }}
        >
            <Typography
                sx={{
                    fontWeight: 700,
                    fontSize: 20,
                    textAlign: 'center',
                }}
                data-cy={'not-allowed-page'}
            >
                {translate('messages.not_allowed')}
            </Typography>
            <Button onClick={() => navigate('/')} variant={'contained'}>
                {translate('messages.go_home')}
            </Button>
        </Box>
    );
};

export default NotAllowedPage;
